import React from "react";
import { Form } from "semantic-ui-react";
import { useExtLabels } from './extLabels'

const Submitter = ({ model, errors = {}, onChange, disabled }) => {
    const l = useExtLabels()

    const handleChange = target => onChange({ ...model, [target.name]: target.value });

    return (
        <React.Fragment>
            <h3>{l('Dane kontaktowe')}</h3>
            <Form.Input
                disabled={disabled}
                label={l("Imię i nazwisko zgłaszającego")}
                name="name"
                value={model.name}
                onChange={({ target }) => handleChange(target)}
                required
                error={!!errors.name}
            />
            <Form.Group widths="equal">
            <Form.Input
                disabled={disabled}
                label={l("Adres e-mail")}
                type="email"
                name="email"
                value={model.email}
                onChange={({ target }) => handleChange(target)}
                required
                error={!!errors.email}
            />
            <Form.Input
                disabled={disabled}
                label={l("Telefon")}
                name="phone"
                value={model.phone}
                onChange={({ target }) => handleChange(target)}
                required
                pattern="[\d -]+"
                error={!!errors.phone}
            />
            </Form.Group>
        </React.Fragment>
    );
};

export default Submitter;